type BlockArgsInput = {
  dateFilter?: any;
  teamFilter?: any;
  objectId?: string;
};

export const buildBlockArgs = ({
  dateFilter,
  teamFilter,
  objectId,
}: BlockArgsInput) => {
  const hasDateFilter = dateFilter && Object.keys(dateFilter).length > 0;
  const hasTeamFilter = teamFilter && Object.keys(teamFilter).length > 0;
  return {
    dateFilter: hasDateFilter
      ? { start: dateFilter.start, end: dateFilter.end }
      : undefined,
    teamFilter: hasTeamFilter
      ? {
          teamMembers: teamFilter.teamMembers ?? [],
          roles: teamFilter.roles ?? [],
        }
      : undefined,
    objectId: objectId ?? undefined,
  };
};
